import React from "react";

export const NormalHeader = ({ children }) => {
  return (
    <h1 className="text-center text-black font-medium text-2xl mb-8 tracking-tight">
      {children}
    </h1>
  )
};
